var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.params.value)+" "),_c('fa-icon',{staticClass:"ml-2 cursor-pointer",attrs:{"icon":"link"},on:{"click":function($event){return _vm.openWhatsapp(_vm.params.value)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }